import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { LabCorpEdifecsStandardCompendium } from '../../models/lab-corp-edifecs-standard-compendium';

const getOtherLabCorpEdifecsStandardCompendiumIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<LabCorpEdifecsStandardCompendium>) => memoize((
        ids: Undefinable<string>[]
    ) => ids.filter(x => x && !byId[x]) as string[])
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherLabCorpEdifecsStandardCompendiumIds: (
        state: State,
        ids: Undefinable<string>[]
    ): string[] => getOtherLabCorpEdifecsStandardCompendiumIdsSelector(state)(ids),
    getLabCorpEdifecsStandardCompendium: (
        state: State,
        id: Undefinable<string>
    ): Undefinable<LabCorpEdifecsStandardCompendium> => state.byId[id || '']
};
